import React, { useRef, useState } from "react";

/* 8 alternating card themes — teal & orange brand palette */
const CARD_THEMES = [
  { bg:"bg-gradient-to-b from-[#eaf4f3] to-white", border:"border-[#c5d5d4] hover:border-[#5fbdb3]", accent:"from-[#1e4a46] via-[#5fbdb3] to-[#1e4a46]", imgRing:"bg-[#d4ecea]/60 border-[#c5d5d4]", text:"text-[#1e4a46] group-hover:text-[#3a7a74]", shadow:"shadow-[0_2px_12px_rgba(95,189,179,0.12)] hover:shadow-[0_10px_28px_rgba(95,189,179,0.25)]", dot:"bg-[#5fbdb3]" },
  { bg:"bg-gradient-to-b from-[#fff3ee] to-white", border:"border-[#ffd5c2] hover:border-[#ff601e]", accent:"from-[#ff601e] via-[#ffd5c2] to-[#ff601e]", imgRing:"bg-[#ffd5c2]/50 border-[#ffd5c2]", text:"text-[#cc4c18] group-hover:text-[#ff601e]", shadow:"shadow-[0_2px_12px_rgba(255,96,30,0.10)] hover:shadow-[0_10px_28px_rgba(255,96,30,0.24)]", dot:"bg-[#ff601e]" },
  { bg:"bg-gradient-to-b from-[#f4fbfa] to-white", border:"border-[#d4ecea] hover:border-[#3a7a74]", accent:"from-[#3a7a74] via-[#5fbdb3] to-[#3a7a74]", imgRing:"bg-[#eaf4f3]/80 border-[#d4ecea]", text:"text-[#284b49] group-hover:text-[#1e4a46]", shadow:"shadow-[0_2px_12px_rgba(58,122,116,0.10)] hover:shadow-[0_10px_28px_rgba(58,122,116,0.22)]", dot:"bg-[#5fbdb3]" },
  { bg:"bg-gradient-to-b from-[#fff8f0] to-white", border:"border-[#ffd5c2] hover:border-[#ff601e]/70", accent:"from-[#ff601e] to-[#e55519]", imgRing:"bg-[#fff3ee]/80 border-[#ffd5c2]", text:"text-[#c44a14] group-hover:text-[#ff601e]", shadow:"shadow-[0_2px_12px_rgba(255,96,30,0.08)] hover:shadow-[0_10px_28px_rgba(255,96,30,0.20)]", dot:"bg-[#ff601e]" },
  { bg:"bg-gradient-to-b from-[#eaf4f3] to-[#f8fafa]", border:"border-[#c5d5d4] hover:border-[#5fbdb3]", accent:"from-[#5fbdb3] to-[#1e4a46]", imgRing:"bg-[#d4ecea]/50 border-[#c5d5d4]", text:"text-[#1e4a46] group-hover:text-[#3a7a74]", shadow:"shadow-[0_2px_12px_rgba(95,189,179,0.10)] hover:shadow-[0_10px_28px_rgba(95,189,179,0.22)]", dot:"bg-[#5fbdb3]" },
  { bg:"bg-gradient-to-b from-[#fff3ee] to-[#f8fafa]", border:"border-[#ffd5c2] hover:border-[#ff601e]", accent:"from-[#e55519] via-[#ff601e] to-[#e55519]", imgRing:"bg-[#ffd5c2]/40 border-[#ffd5c2]", text:"text-[#cc4c18] group-hover:text-[#ff601e]", shadow:"shadow-[0_2px_12px_rgba(255,96,30,0.09)] hover:shadow-[0_10px_28px_rgba(255,96,30,0.20)]", dot:"bg-[#ff601e]" },
  { bg:"bg-gradient-to-b from-[#f0f9f8] to-white", border:"border-[#d4ecea] hover:border-[#5fbdb3]", accent:"from-[#162c2a] via-[#5fbdb3] to-[#162c2a]", imgRing:"bg-[#eaf4f3]/70 border-[#d4ecea]", text:"text-[#162c2a] group-hover:text-[#1e4a46]", shadow:"shadow-[0_2px_12px_rgba(22,44,42,0.09)] hover:shadow-[0_10px_28px_rgba(22,44,42,0.18)]", dot:"bg-[#5fbdb3]" },
  { bg:"bg-gradient-to-b from-[#fffaf7] to-white", border:"border-[#ffd5c2] hover:border-[#ff601e]/60", accent:"from-[#ff601e] to-[#ffd5c2]", imgRing:"bg-[#fff3ee]/70 border-[#ffd5c2]", text:"text-[#b84412] group-hover:text-[#ff601e]", shadow:"shadow-[0_2px_12px_rgba(255,96,30,0.07)] hover:shadow-[0_10px_28px_rgba(255,96,30,0.18)]", dot:"bg-[#ff601e]" },
];

/* ── Fallback SVG — shown when image is missing or broken ── */
const FallbackImg = () => (
  <svg width="100%" height="100%" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Pill capsule — horizontal */}
    <rect x="10" y="35" width="80" height="30" rx="15" fill="#eaf4f3" stroke="#c5d5d4" strokeWidth="2"/>
    {/* Left half — teal */}
    <path d="M10 50C10 41.7 16.7 35 25 35H50V65H25C16.7 65 10 58.3 10 50Z" fill="#5fbdb3" fillOpacity="0.55"/>
    {/* Right half — orange */}
    <path d="M90 50C90 58.3 83.3 65 75 65H50V35H75C83.3 35 90 41.7 90 50Z" fill="#ff601e" fillOpacity="0.50"/>
    {/* Center dashed divider */}
    <line x1="50" y1="35" x2="50" y2="65" stroke="white" strokeWidth="1.5" strokeDasharray="3 2.5"/>
    {/* Small pills */}
    <ellipse cx="24" cy="22" rx="9" ry="5.5" fill="#d4ecea" stroke="#5fbdb3" strokeWidth="1.5"/>
    <line x1="24" y1="16.5" x2="24" y2="27.5" stroke="#5fbdb3" strokeWidth="1.2" strokeDasharray="2 1.5"/>
    <ellipse cx="76" cy="79" rx="9" ry="5.5" fill="#ffd5c2" stroke="#ff601e" strokeWidth="1.5"/>
    <line x1="76" y1="73.5" x2="76" y2="84.5" stroke="#ff601e" strokeWidth="1.2" strokeDasharray="2 1.5"/>
    {/* Cross / plus */}
    <rect x="20" y="70" width="3" height="12" rx="1.5" fill="#5fbdb3" fillOpacity="0.5"/>
    <rect x="15.5" y="74.5" width="12" height="3" rx="1.5" fill="#5fbdb3" fillOpacity="0.5"/>
    <rect x="72" y="16" width="3" height="12" rx="1.5" fill="#ff601e" fillOpacity="0.45"/>
    <rect x="67.5" y="20.5" width="12" height="3" rx="1.5" fill="#ff601e" fillOpacity="0.45"/>
  </svg>
);

/* ── Per-image component with fallback ── */
const ConcernImage = ({ src, alt, className }) => {
  const [failed, setFailed] = useState(false);
  if (!src || failed) {
    return (
      <div className={`${className} flex items-center justify-center`}>
        <FallbackImg />
      </div>
    );
  }
  return (
    <img
      src={src}
      alt={alt}
      className={`${className} object-contain`}
      onError={() => setFailed(true)}
    />
  );
};

/* Inline SVG fallback — medicine capsule pill */
const FALLBACK_SVG = `data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='8' y='28' width='64' height='24' rx='12' fill='%23eaf4f3' stroke='%23c5d5d4' stroke-width='2'/%3E%3Cpath d='M8 40C8 33.4 13.4 28 20 28H40V52H20C13.4 52 8 46.6 8 40Z' fill='%235fbdb3' opacity='0.5'/%3E%3Cpath d='M72 40C72 46.6 66.6 52 60 52H40V28H60C66.6 28 72 33.4 72 40Z' fill='%23ff601e' opacity='0.45'/%3E%3Cline x1='40' y1='28' x2='40' y2='52' stroke='white' stroke-width='1.5' stroke-dasharray='3 2'/%3E%3C/svg%3E`;

const Shopbyconcern = ({ apiConcern, handleclikforconcern, backgroundImagesConcern }) => {
  const scrollRef = useRef(null);

  const handleScroll = (direction) => {
    if (!scrollRef.current) return;
    scrollRef.current.scrollBy({ left: direction === "left" ? -210 : 210, behavior: "smooth" });
  };

  return (
    <section className="w-full py-8 sm:py-6 lg:py-6 px-4 sm:px-6 lg:px-6 xl:px-6 font-poppins">

      {/* ── Section header ── */}
      <div className="flex items-end justify-between mb-6 sm:mb-8">
        <div>
          <div className="flex items-center gap-2 mb-1.5">
            <span className="w-5 h-[2px] bg-[#ff601e] rounded-full" />
            <span className="text-[10px] sm:text-[11px] font-bold uppercase tracking-widest text-[#ff601e]">
              Health Goals
            </span>
          </div>
          <h2 className="font-bold text-[20px] sm:text-[24px] lg:text-[28px] text-[#1e4a46] leading-tight">
            Shop by Concern
          </h2>
          <p className="text-[13px] text-[#8faba9] mt-1 hidden sm:block">
            Find products tailored to your specific health needs
          </p>
        </div>
      </div>

      {/* ── Carousel ── */}
      <div className="relative">

        {/* Left arrow */}
        <button
          onClick={() => handleScroll("left")}
          className="absolute -left-3 sm:-left-5 top-1/2 -translate-y-1/2 z-20
            w-8 h-8 sm:w-10 sm:h-10 rounded-xl bg-white border-[1.5px] border-[#e2eaea]
            shadow-[0_2px_10px_rgba(22,44,42,0.1)] flex items-center justify-center
            text-[#374747] hover:bg-[#eaf4f3] hover:border-[#5fbdb3] hover:text-[#1e4a46]
            transition-all duration-200"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M19 12H5M12 5l-7 7 7 7"/>
          </svg>
        </button>

        {/* Scrollable row */}
        <div
          ref={scrollRef}
          className="flex gap-3 sm:gap-4 overflow-x-auto scrollbar-hide scroll-smooth px-1 py-3"
        >
          {apiConcern.map((concern, index) => {
            const t = CARD_THEMES[index % CARD_THEMES.length];

            return (
              <button
                key={index}
                onClick={() => handleclikforconcern(concern.concern_id, concern.name)}
                className={`group flex-shrink-0 w-[160px] 
                  h-[175px] 
                  rounded-2xl flex flex-col items-center justify-between
                  p-3 sm:p-4 relative overflow-hidden cursor-pointer
                  border-[1.5px] ${t.border} ${t.bg} ${t.shadow}
                  hover:-translate-y-2 transition-all duration-300`}
              >
                {/* Watermark SVG bg */}
                <img
                  src={backgroundImagesConcern[index % backgroundImagesConcern.length]}
                  alt=""
                  className="absolute inset-0 w-full h-full object-cover opacity-[0.055] pointer-events-none select-none"
                />

                {/* Animated top accent bar */}
                <div className={`absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r ${t.accent}
                  opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10`} />

                {/* Small decorative corner dot */}
                <div className={`absolute top-2.5 right-2.5 w-2 h-2 rounded-full ${t.dot}
                  opacity-25 group-hover:opacity-70 group-hover:scale-125 transition-all duration-300 z-10`} />

                {/* Image inside a soft ring — full fitted */}
                <div className="relative z-10 flex-1 w-full flex items-center justify-center">
                  <div className={`w-[80px] h-[80px] sm:w-[90px] sm:h-[90px] lg:w-[100px] lg:h-[100px]
                    rounded-2xl ${t.imgRing} border overflow-hidden
                    flex items-center justify-center
                    group-hover:scale-105 transition-transform duration-300`}>
                    <ConcernImage
                      src={concern.image_url}
                      alt={concern.name}
                      className="w-full h-full group-hover:scale-110 transition-transform duration-300"
                    />
                  </div>
                </div>

                {/* Thin divider */}
                <div className="w-full h-px bg-black/[0.05] my-1.5 relative z-10" />

                {/* Name */}
                <p className={`relative z-10 text-center text-[11px] sm:text-[12px] lg:text-[13px]
                  font-semibold ${t.text} leading-snug line-clamp-2 transition-colors duration-200 pb-0.5`}>
                  {concern.name}
                </p>
              </button>
            );
          })}
        </div>

        {/* Right arrow */}
        <button
          onClick={() => handleScroll("right")}
          className="absolute -right-3 sm:-right-5 top-1/2 -translate-y-1/2 z-20
            w-8 h-8 sm:w-10 sm:h-10 rounded-xl bg-white border-[1.5px] border-[#e2eaea]
            shadow-[0_2px_10px_rgba(22,44,42,0.1)] flex items-center justify-center
            text-[#374747] hover:bg-[#eaf4f3] hover:border-[#5fbdb3] hover:text-[#1e4a46]
            transition-all duration-200"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 12h14M12 5l7 7-7 7"/>
          </svg>
        </button>
      </div>
    </section>
  );
};

export default Shopbyconcern;